import {IRequestField} from "../interfaces/configuration";

export const CARD_ICONS: Array<string> = ['visa', 'mastercard', 'diners', 'amex', 'jcb', 'discover', 'maestro'];

export const DEFAULT_REQUEST_FIELDS: { [key: string]: IRequestField } = {
  transactionType: {
    order: 10,
    mapping: 'transaction_type',
    label: 'Transaction Type',
    placeholder: 'Select Transaction Type',
    component: 'radio',
    valid: true,
    value: 'pay',
    readOnly: false,
    hidden: false,
    possibleValues: {pay: 'Pay', pay_and_tokenise: 'Pay and Tokenise', tokenise: 'Tokenise'},
    hideRelatedFields: {
      pay: {amount: false, paymentReference: false, tokenReference: true},
      pay_and_tokenise: {amount: false, paymentReference: false, tokenReference: false},
      tokenise: {amount: true, paymentReference: true, tokenReference: false}
    }
  },
  amount: {
    order: 20,
    label: 'Amount',
    placeholder: 'Enter amount',
    component: 'currency',
    valid: false,
    readOnly: false,
    hidden: false,
    min: 0.01,
    max: 999999.99
  },
  paymentReference: {
    order: 30,
    mapping: 'payment_reference',
    label: 'Payment Ref',
    placeholder: 'Payment Reference',
    component: 'string',
    valid: false,
    readOnly: false,
    hidden: false
  },
  tokenReference: {
    order: 40,
    mapping: 'token_reference',
    label: 'Customer Ref',
    placeholder: 'Customer ID or Reference',
    component: 'string',
    valid: false,
    readOnly: false,
    hidden: false
  },
  nameOnCard: {
    order: 50,
    mapping: 'name_on_card',
    label: 'Name On Card',
    component: 'string',
    valid: false,
    readOnly: false,
    hidden: false
  },
  gatewayName: {
    order: 60,
    mapping: 'metadata.gateway_name',
    label: 'Gateway',
    component: 'select',
    valid: false,
    readOnly: false,
    hidden: true,
    possibleValues: {default: 'Default Gateway'}
  },
  pan: {
    order: 100,
    label: 'Card Number',
    component: 'secure-pan',
    valid: false,
    secure: true,
    readOnly: false,
    hidden: false
  },
  expiry: {
    order: 110,
    label: 'Expiry Date',
    component: 'secure',
    valid: false,
    secure: true,
    readOnly: false,
    hidden: false
  },
  cvv: {
    order: 120,
    label: 'CVV',
    component: 'secure',
    secure: true,
    valid: false,
    readOnly: false,
    hidden: false
  },
  metadata: {order: 1000, label: 'Metadata', component: 'metadata', valid: true, readOnly: false, hidden: true},
};
